/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ProjectActive', ProjectActive);

    ProjectActive.$inject = ['$resource', 'DateUtils'];

    function ProjectActive ($resource, DateUtils) {
        var resourceUrl =  'api/board/projects/active';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for(var index = 0; index < data.length; index++) {
                            data[index].fromDate = DateUtils.convertLocalDateFromServer(data[index].fromDate);
                            data[index].untilDate = DateUtils.convertLocalDateFromServer(data[index].untilDate);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();
